var render, staticRenderFns
import script from "./lb-render.vue?vue&type=script&lang=js"
export * from "./lb-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e24a0c')) {
      api.createRecord('48e24a0c', component.options)
    } else {
      api.reload('48e24a0c', component.options)
    }
    
  }
}
component.options.__file = "src/components/lb-table3/lb-render.vue"
export default component.exports